import React, { useMemo } from 'react';
import classNames from 'classnames';

import { secondsToDisplayTime } from 'common/support/stringHelper';
import ProgressBar from 'components/common/ProgressBar';

import styles from './PlaybackTimeline.module.scss';

interface PlaybackTimelineProps {
  className?: string | null;
  durationInSeconds?: number;
  progressInSeconds?: number;
  cuePoints?: number[];
}

const PlaybackTimeline = ({
  durationInSeconds = 0,
  progressInSeconds = 0,
  className = null,
  cuePoints = [],
}: PlaybackTimelineProps) => {
  const value = progressInSeconds / durationInSeconds;
  const filteredCuePoints = useMemo(() => cuePoints.filter(time => time > 0), [
    cuePoints,
  ]);

  return (
    <div
      className={classNames('d-flex', styles.wrapper, className)}
      data-testid="playback-timeline"
    >
      <div className={classNames('text-nowrap', 'd-flex', styles.progress)}>
        {secondsToDisplayTime(progressInSeconds)}
      </div>

      <div className="flex-grow-1 position-relative">
        <ProgressBar
          className={classNames(styles.bar, 'w-100')}
          fillerClassName={styles.filler}
          value={value || 0}
        />
        {filteredCuePoints.map(time => (
          <div
            className={classNames(
              'position-absolute',
              'h-100',
              styles.cuePoint,
            )}
            key={time}
            style={{ left: `${(time / durationInSeconds) * 100}%` }}
          />
        ))}
      </div>
      <div
        className={classNames(
          'text-nowrap',
          'd-flex',
          'justify-content-end',
          styles.timeRemaining,
        )}
      >
        {`-${secondsToDisplayTime(durationInSeconds - progressInSeconds)}`}
      </div>
    </div>
  );
};

export default PlaybackTimeline;
